import React, { useEffect, useState } from "react";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import PageHeader from "../../../shared/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  itemListGeneralInfo,
  manageCostsDetailTableColumns,
  packageTableColumnsData,
  priceInPatient,
  priceOutPatient,
  priceemergency,
  payersTableColumnsData
} from "../../../constants/PriceListConstants";
import ListDetailsCard from "../../../shared/ListDetailsCard";
import CustomTable from "../../../shared/CustomTable";

function PriceListViewPage() {
  const navigate = useNavigate();
  const { t,i18n } = useTranslation();
  const location = useLocation();
  const state = location.state;
  const getItemsListDataPayload = state?.getItemsListDataPayload;
  const [item, setItem] = useState(null);
  useEffect(() => {
    if (state && state.item) {
      setItem(state.item);
    }
  }, [location, navigate]);

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <PageHeader
        title={t("PRICELIST")}
        iconSize={20}
        Icon={i18n.dir() === "rtl" ? FaArrowCircleRight : FaArrowCircleLeft}
        onIconClick={() =>
          navigate("/price-list", {
            state: { prevPayload: getItemsListDataPayload },
          })
        }
      ></PageHeader>
      <div className="mt-2">
        <h5 className="text-18-dark !font-[600] mb-2">
          {t("GeneralInformation")}
        </h5>
        <ListDetailsCard listData={itemListGeneralInfo(item, t)} />
      </div>
      <div className="mt-2">
        <div>
          <h5 className="text-18-dark !font-[600] mb-2">
            {t("PricingDetails")}
          </h5>
          <div className="border bg-gray-100 border-gray-100 p-2 rounded ">
            <div>
              <h5 className="text-18-dark !font-[600] mb-2">
                {t("OutPatient")}
              </h5>
              <ListDetailsCard listData={priceOutPatient(item, t)} />
            </div>
            <div>
              <h5 className="text-18-dark !font-[600] mb-2">
                {t("InPatient")}
              </h5>
              <ListDetailsCard listData={priceInPatient(item, t)} />
            </div>
            <div>
              <h5 className="text-18-dark !font-[600] mb-2">
                {t("Emergency")}
              </h5>
              <ListDetailsCard listData={priceemergency(item, t)} />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-2">
        <div>
          <h5 className="text-18-dark !font-[600] mb-2">
            {t("Cost Mangement")}
          </h5>
          <div>
            <CustomTable
              columns={manageCostsDetailTableColumns(t)}
              data={item?.manage_costs || []}
            />
          </div>
        </div>
      </div>
      <div className="my-4">
        {item?.daily_package_deal && (
          <div>
            <h5 className="text-18-dark !font-[600] mb-2">
              {t("Daily Package")}
            </h5>
            <CustomTable
              columns={packageTableColumnsData(t)}
              data={item?.package_detail}
            />
          </div>
        )}
      </div>
      {item?.item_type == "insurance" && (
        <div className="mt-2">
          <h5 className="text-18-dark !font-[600] mb-2">{t("Payer")}</h5>
          <CustomTable
            columns={payersTableColumnsData(t)}
            data={item?.payer_details}
          />
        </div>
      )}
    </div>
  );
}

export default PriceListViewPage;
